import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getPublicWifiCreateAliasError,
  getPublicWifiCreateAliasPending,
  getPublicWifiCreateAliasSuccess,
} from '../../store/reducers';
import { InceptionService, TranslationService } from '@proximus/ng-common';
import { Alert, AlertsService } from '@proximus/ng-common-components';
import * as PublicWifiActions from '../store/actions/public-wifi.actions';
import { PublicWifiAccountFormDirective } from '../public-wifi-account-form/public-wifi-account-form.directive';
import { PublicWifiAccount } from '../store/reducers/public-wifi.reducer';

export enum ViewType {
  DEFAULT,
  SIMPLE,
  CREATE,
}

@Component({
  selector: 'mprd-public-wifi-account-create',
  templateUrl: './public-wifi-account-create.component.html',
  styleUrls: ['./public-wifi-account-create.component.css'],
})
export class PublicWifiAccountCreateComponent
  extends PublicWifiAccountFormDirective
  implements OnInit
{
  @Input() activeAccounts: Array<PublicWifiAccount>;
  ViewType = ViewType;
  selectedViewType = ViewType.DEFAULT;

  createAliasPending = false;

  constructor(
    private store: Store<ApplicationState>,
    private inceptionService: InceptionService,
    private elementRef: ElementRef,
    private translationService: TranslationService,
    private alertService: AlertsService,
  ) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.store.select(getPublicWifiCreateAliasPending).subscribe((res) => {
        if (
          this.getValueWithoutDomain(this.account.technicalLoginId) ===
          res.selectedTechnicalLoginId
        ) {
          this.createAliasPending = res.value;
        }
      }),
    );
    this.addSubscription(
      this.store.select(getPublicWifiCreateAliasSuccess).subscribe((res) => {
        if (this.shouldShowAlert(res)) {
          this.toggleDefault();
          this.resetForm();
          this.showAlert(
            'publicWifi.accountList.manage.createAlias.success.title',
            'publicWifi.accountList.manage.createAlias.success.description',
            'success',
          );
          this.store.dispatch(
            new PublicWifiActions.ResetPublicWifiCreateValues(),
          );
        }
      }),
    );
    this.addSubscription(
      this.store.select(getPublicWifiCreateAliasError).subscribe((res) => {
        if (this.shouldShowAlert(res)) {
          this.showAlert(
            'publicWifi.accountList.manage.createAlias.error.title',
            'publicWifi.accountList.manage.createAlias.error.description',
            'error',
          );
        }
      }),
    );
    this.selectedViewType =
      this.activeAccounts.length >= 1 ? ViewType.SIMPLE : ViewType.DEFAULT;
  }

  toggleCreateMode() {
    this.selectedViewType = ViewType.CREATE;
    setTimeout(() => {
      this.inceptionService.forms(this.elementRef);
    });
  }

  toggleDefault() {
    this.selectedViewType =
      this.activeAccounts.length >= 1 ? ViewType.SIMPLE : ViewType.DEFAULT;
  }

  saveAccount() {
    this.store.dispatch(
      new PublicWifiActions.CreatePublicWifiLoginAlias({
        technicalLoginId: this.getValueWithoutDomain(
          this.account.technicalLoginId,
        ),
        login: this.login,
        password: this.password,
      }),
    );
  }

  private showAlert(
    title: string,
    desc: string,
    type: 'error' | 'info' | 'success' | 'warning',
  ) {
    setTimeout(() => {
      const alert: Alert = {
        isClosable: true,
        alertKey:
          'publicWifiCreateAlert' +
          this.getValueWithoutDomain(this.account.technicalLoginId),
        title: this.translationService.getTranslatedValueFor(title),
        description: this.translationService.getTranslatedValueFor(desc),
        type,
      };
      this.alertService.dispatchAlert(alert);
    });
  }

  cancel() {
    this.toggleDefault();
    this.resetForm();
  }
}
